module.exports = __webpack_public_path__ + "static/media/Article_facteur_transmission_L_Bourgois.7fe6e3a2.pdf";